import React, {useState,useContext, useEffect,useRef, Suspense } from "react";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { PageContext } from "./PageContext";
import { SubmissionContext } from "./SubmissionFormContext";
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { Form, FormElement, FormSubmitClickEvent } from '@progress/kendo-react-form';
import { Stepper } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';
import { SubmitBasic } from './SubmitBasic';
import {SubmitNotations} from './SubmitNotations';
import { SubmitCustom } from './SubmitCustom';
import { SubmitFile } from './SubmitFile';
import { SubmitHold } from './SubmitHold';
import { SubmitPickup } from './SubmitPickup';
import { SubmitPickupTo } from "./SubmitPickupTo";
import { SubmitPickupComp } from './SubmitPickupComp';
import { SubmitComplete, SubmitSummary, SummaryReport} from './SubmitSummary';
import { SubmitInstructions } from './SubmitInstructions';
import { SubmitSizes } from "./SubmitSizes";
import { SubmitRunDates } from "./SubmitRunDates";
import { SubmissionContextProvider } from "./SubmissionFormContext";
import { CustomFormField, JobTicketForm, salesRep, SubToProcess,HistoryEntry, NewRunDate } from "../services/interfaces";
import { Notification, NotificationEvent } from "@progress/kendo-react-notification";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ProgressBar, ProgressBarAnimation } from "@progress/kendo-react-progressbars";
import { processSubmission,getSiteFlag,writeToHistory, addWatchList, saveAnnotations, getAdExists, getCreatopyURL} from "../services/apiService";
import { ConfirmDialog } from "./ConfirmDialog";
import { UserContext } from "./UserContext";
import { flushSync } from "react-dom";
import { Loader } from "@progress/kendo-react-indicators";

interface SubmissionFormProps{
    title:string;
    type:string;
    onClose:()=>void;
}


interface iSteps{
    label:string;
    isValid:boolean|undefined;
}

export function SubmissionForm(props:SubmissionFormProps){
    const jobTicketRef = useRef<HTMLDivElement | null>(null);
    const [stepPages,SetStepPages] = useState([SubmitBasic, SubmitSizes, SubmitRunDates, SubmitFile, SubmitCustom, SubmitInstructions, SubmitPickup, SubmitPickupComp, SubmitSummary, SubmitHold]);
    const [step, setStep] = useState(0);
    const [width, setWidth]=useState(()=>{
        const vw = window.innerWidth*.9;
        return vw;
    });
    const [height, setHeight]=useState(()=>{
        const vh = window.innerHeight*.9;
        return vh;
    });
    const [formState, setFormState] = useState({});
    const [steps, setSteps] = useState<iSteps[]>([
        { label: 'Ad Info', isValid: undefined },
        { label: 'Sizes', isValid: undefined },
        { label: 'Rundates', isValid: undefined },
        { label: 'Files', isValid: undefined },
        { label: 'Details', isValid: undefined },
        { label: 'Instructions', isValid: undefined },
        { label: 'Summary', isValid: undefined },
        { label: 'Hold', isValid: undefined },
        { label: 'Result', isValid:undefined}
    ]);

    const [stepValid, setStepValid] = useState(false);
    const [windowContent, setWindowContent]=useState("form");
    const [showValidationAlert, setShowValidationAlert]=useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [showLoader,setShowLoader]=useState(false);

    const [uploadResults, setUploadResults] = useState<any[]>([]);
    const [uploadComplete, setUploadComplete]=useState(false);
    const [ticketComplete, setTicketComplete] = useState("");
    const [processComplete, setProcessComplete] = useState("");
    const [watchComplete, setWatchComplete] = useState("");
    const [showTicketStatus, setShowTicketStatus]= useState(false);
    const [showProcessStatus, setShowProcessStatus]= useState(false);
    const [showCloseConfirm, setShowCloseConfirm]= useState(false);
    const [showConfirmOpenAd, setShowConfirmOpenAd]= useState(false);
    const [creatopyUrl, setCreatopyUrl]=useState("");
    const [ticketReady, setTicketReady]=useState(false);
    const [progress, setProgress]=useState(0);
    const [progressMax,setProgressMax]=useState(10);
    const [statuses, setStatuses]=useState([]);
    const pageContext=useContext(PageContext);
    const subContext = useContext(SubmissionContext);
    const userContext = useContext(UserContext);
    const lastStepIndex = steps.length - 1;
    const isLastStep = lastStepIndex === step;
    const isPreviousStepsValid = steps.slice(0, step).findIndex((currentStep) => currentStep.isValid === false) === -1;
    const thisFormBody = useRef<HTMLDivElement>(null);
    const [promptPickup, setPromptPickup]=useState(false);
    const saveUploadResults=(data:any)=>{       
        console.log(data);
        var prevData = uploadResults;
        console.log(prevData);
        prevData.push(data);
        setUploadResults(prevData);
    }

    const confirmOpenAd=()=>{
        setShowConfirmOpenAd(true);
    }

    const closeConfirmOpenAd=()=>{
        setShowConfirmOpenAd(false);
    }

    const openExternalAd=async ()=>{
        console.log("Open External Ad");
        setShowLoader(true);
        const adnum = subContext?.submitForm.element;
        getCreatopyURL(adnum).then(extURL=>{
            if (extURL){
                console.log(extURL);
                if (extURL.startsWith("https")){
                    window.location.replace(extURL.toString());
                }
            }
        });
    }
    
    const completeUpload=()=>{
        setUploadComplete(true);
    }

    const completeTicket=(resp:string)=>{
        setTicketComplete(resp);        
    }

    const completeProcess=(resp:string)=>{
        setProcessComplete(resp);        
    }
    
    const changeProgress=()=>{
        console.log("Change Progress");
        setProgress(prevState => prevState + 1);        
    }

    const uploadFile= async (file:any)=>{
        var uploadData = new FormData();
        if (file.getRawFile) {
                uploadData.append("file", file.getRawFile(), file.name);
        }
        var element:string = "";
        if (subContext?.submitForm.element.includes(".INDD")||subContext?.submitForm.element.includes(".FLA")){
            element=subContext?.submitForm.element||"";
        }else{
            //need to add an extension to the element field.
            if (subContext?.submitForm.adType.value=="DA"){
                //print ads
                element=subContext?.submitForm.element+".INDD"||"";
            }else{
                //online ads
                element=subContext?.submitForm.element+".FLA"||"";
            }
        }
        if (subContext){
            uploadData.append("element", element);
            uploadData.append("site",subContext.submitForm.site.code);
            uploadData.append("account",subContext.submitForm.account);
            uploadData.append("customer",subContext.submitForm.customer.customer);
            uploadData.append("pressReady",subContext.submitForm.prCheck.toString());    
        }
        const url = "/api/UploadFiles";
        const header = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        try {
            const response = await axios.post(url, uploadData, header);
            if (response.status !== 200) {
                throw new Error(`Response status: ${response.status}`);
            } else {
                const data = response.data;
                console.log(data);
                setUploadResults(prevState=>[...prevState,data]);
                changeProgress();
            }
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message);
                setUploadResults(prevState=>[...prevState,"Error uploading " + file.name + " - " + error.message]);
                changeProgress();
            } else {
                console.error('An unknown error occurred');
            }
            return "error";
        }
    }

    const uploadFiles=async ()=>{
        var counter=0;      

        if (subContext?.files){
            const maxFiles=subContext.files.length;
            for (let i = 0; i<subContext?.files.length;i++){
                console.log("Processing file: " + i);
                if (i==maxFiles){
                    completeUpload();
                }
                let file = subContext?.files[i];
                //console.log(file);
                await uploadFile(file).then(data=>{
                    console.log(data);
                });
            }
        }
    }
    //const jobTicket = jobTicketRef.current;
    
    //subContext?.submitForm.ticket||"";
    
    const makeJobTicket=async()=>{
        const tickComp = jobTicketRef.current;
        const jobTicket =tickComp?.outerHTML;
        console.log("Make Job Ticket");
        console.log(jobTicket);
        const tickString = jobTicket;
        var dayOfMonth = 1;
        if (subContext?.submitForm.subType!="SB" && subContext?.submitForm.subType!="CR" && subContext?.submitForm.subType!="SP" && subContext?.submitForm.subType!="AI"){
            dayOfMonth = subContext?.submitForm.runDates[0].startDate.getDate()||0;
        }
        var dateForPath="";
        if (dayOfMonth<10){
            dateForPath="0"+dayOfMonth;
        }else{
            dateForPath=dayOfMonth.toString();
        }
        var element:string = "";
        if (subContext?.submitForm.element.includes(".INDD")||subContext?.submitForm.element.includes(".FLA")){
            element=subContext?.submitForm.element||"";
        }else{
            //need to add an extension to the element field.
            if (subContext?.submitForm.adType.value=="DA"){
                //print ads
                element=subContext?.submitForm.element+".INDD"||"";
            }else{
                //online ads
                element=subContext?.submitForm.element+".FLA"||"";
            }
        }
        if (subContext && element!="" && subContext?.submitForm.adType.value!="" && subContext?.submitForm.slug!="" ){
            const jobTikForm:JobTicketForm={
                ticket:tickString || "",
                element:element,
                elementType:subContext?.submitForm.adType.value,
                slug:subContext?.submitForm.slug
            }
            const tikJSON = JSON.stringify(jobTikForm);
            var tickData = new FormData();
            tickData.append("ticketBody",jobTikForm.ticket);
            tickData.append("element",jobTikForm.element);
            tickData.append("slug",jobTikForm.slug);
            tickData.append("elementType",jobTikForm.elementType);
            tickData.append("site",subContext?.submitForm.site.code);
            tickData.append("date", dateForPath?.toString() || "");
            tickData.append("siteFlag",subContext.submitForm.siteFlag);
            tickData.append("account",subContext.submitForm.account);
            const url = "/api/SaveJobTicket";
            const header = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            try {
                const response = await axios.post(url, tickData, header);
                if (response.status !== 200) {
                    throw new Error(`Response status: ${response.status}`);
                } else {
                    const data = response.data;
                    console.log(data);
                    return ("200");                
                }
            } catch (error) {
                if (error instanceof Error) {
                    console.error(error.message);
                } else {
                    console.error('An unknown error occurred');
                }
                return "error";
            }
        }
    }

    const validateActiveTab=()=>{
        var stepValid:boolean=false;
        const activeTab = steps[step].label;
        switch (activeTab){
            case "Ad Info":
                const validBasic = subContext?.submitValid.basic;
                console.log(validBasic);                
                if (validBasic){
                    stepValid=true;
                    setShowValidationAlert(false);
                }else{
                    stepValid=false;
                    setValidationMsg("Highlighted fields are required.");
                    setShowValidationAlert(true);
                }                 
                break;
            case "Sizes":
                const validSize = subContext?.submitValid.sizes;
                console.log(validSize);                
                if (validSize){
                    stepValid=true;
                    setShowValidationAlert(false);
                }else{
                    stepValid=false;
                    setValidationMsg("Please select a type and size.");
                    setShowValidationAlert(true);
                }
                break;
            case "Rundates":
                const validDates = subContext?.submitValid.dates;
                console.log(validDates);                
                if (validDates){
                    stepValid=true;
                    setShowValidationAlert(false);
                }else{
                    stepValid=false;
                    setValidationMsg("Please set at least one run date.");
                    setShowValidationAlert(true);
                }
                break;
            case "Files":
                stepValid=true;
                break;
            case "Instructions":
                stepValid=true;
                break;
            case "Hold":
                stepValid=true;
                break;
            case "Annotations":
                stepValid=true;
                break;
            case "Pickup":
                const validPickup = validatePickup();                    
                console.log(validPickup);
                if (!validPickup){
                    //subContext?.setSubmitValid({...subContext.submitValid, pickup: false});
                    stepValid=false;
                    setValidationMsg("Please select one or more ads to pickup from.");
                    setShowValidationAlert(true);
                }else{
                    stepValid=true
                    setShowValidationAlert(false);
                }
                break;
            case "PickupTo":
                const validPickupTo = validatePickupTo();  
                console.log(validPickupTo);
                if (!validPickupTo){
                    stepValid=false;
                    setValidationMsg("Please select an ad to pickup to.");
                    setShowValidationAlert(true);
                }else{
                    stepValid=true;
                    setShowValidationAlert(false);
                }
                break;
            case "Details":
                //const validCustom = validateCustom();
                console.log(subContext?.fields);
                const custValid = validateCustom();    
                //subContext?.setSubmitValid({...subContext.submitValid, custom: custValid});
                console.log("Validate Custom: " + custValid)
                if (custValid){
                    stepValid=true;
                    setShowValidationAlert(false);
                }else{
                    stepValid=false;
                    setValidationMsg("Highlighted fields are required.");
                    setShowValidationAlert(true);
                }    
                break;
            case "Hold Notes":
                stepValid=true;
                break;
            case "Summary":
                stepValid=true;
                break;
        }   
        return stepValid;      
    }

    const validateCustomAdNumber=async ()=>{
        //validate custom ad number is unique
        const data = await getAdExists(subContext?.submitForm.element);
        if (data && data.Value!=="False"){
            const subValid = subContext?.submitValid;
            if (subValid) {
                subValid.basic = false;
                if (subContext) {
                    subContext.submitValid = subValid;
                }
            }
            setValidationMsg("The supplied ad number already exists. The new order form can not be used to submit to existsing ads.");
            setShowValidationAlert(true);
            return false;
        }
        return true;
    }

    const onNext=async (event:FormSubmitClickEvent)=>{
        console.log(subContext?.submitValid);
        var stepValid = validateActiveTab();
        if (steps[step].label==="Ad Info"){
            await validateCustomAdNumber().then(data=>{
                console.log("Validate custom ad number");
                console.log(data);
                if (!data){
                    stepValid=false;
                }
            });
        }
        console.log(stepValid);
        if (stepValid){
            if (steps[step].label==="Instructions"){
                if (subContext?.pickupWarning){
                    console.log("Looks like a pickup to me");
                    setPromptPickup(true);
                }
            }
            
            const currentSteps = steps.map((currentStep, index) => ({
                ...currentStep,
                isValid: index === step ? event.isValid : currentStep.isValid
            }));
            setSteps(currentSteps);
            setStep(() => Math.min(step + 1, lastStepIndex));
            setFormState(event.values);

            if (isLastStep && isPreviousStepsValid && event.isValid) {
                setWindowContent("result");
                processUpload();
            }    
        }
    }

    const onStepSubmit = React.useCallback(
        (event:FormSubmitClickEvent) => {
            var { isValid, values } = event;
            //console.log(event);
            //const activeTab = steps[step].label;
            //console.log (activeTab);
            //console.log(subContext?.submitForm);
            //Validate the current step pane
            var stepValid = validateActiveTab();
               
            //console.log(subContext?.submitValid);
            console.log (stepValid);
            if (stepValid){
                const currentSteps = steps.map((currentStep, index) => ({
                    ...currentStep,
                    isValid: index === step ? isValid : currentStep.isValid
                }));
                setSteps(currentSteps);
                setStep(() => Math.min(step + 1, lastStepIndex));
                setFormState(values);
    
                if (isLastStep && isPreviousStepsValid && isValid) {
                    setWindowContent("result");
                    processUpload();
                    //uploadFiles();

                    //alert(JSON.stringify(values));
                }    
            }
        },
        [steps, isLastStep, isPreviousStepsValid, step, lastStepIndex]
    );

    const onPrevClick = React.useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            setStep(() => Math.max(step - 1, 0));
        },
        [step, setStep]
    );

   function isHold(){
        return (pageContext?.atolStatuses.HoldStatuses.indexOf(pageContext?.selectedAd.status ?? '') != -1);
   }

   const closeValidation=(event:NotificationEvent)=>{
        setShowValidationAlert(false);
   }
   
   const validatePickup=()=>{
        var result = true;
        if (subContext?.submitForm.pickupWithChanges==true && subContext.submitForm.pickup==""){
            result=false;
        }

        return result;
   }

   const validatePickupTo=()=>{
        var result = true;
        console.log("Validate Pickup To:");
        console.log(subContext?.submitForm.pickup);
        if (subContext?.submitForm.pickup==""){
            result=false;
        }
        return result;
   }

   const validateCustom=()=>{
        var allFieldsValid = true; 
        console.log("In Validate Custom");        
        var fieldValid = true;
        if (subContext?.fields){
            if (subContext.fields.length>0){
                subContext.fields.forEach((field:CustomFormField)=>{
                    if (field.fieldID==9020){
                        console.log("FOO");
                    }
                    var element=document.getElementsByClassName("atolField-"+field.fieldID)[0];
                    if(element){
                        if (element.className.includes("k-invalid")||element.parentElement?.className.includes("k-invalid")){
                            console.log("Custom Form Invalid");
                            fieldValid=false;
                        }
                    }
                });
                console.log("FieldValid: " + fieldValid);
                allFieldsValid=fieldValid;
            }else{
                console.log("Field Array empty");
            }
        }else{
            console.log("Field Array undefined");
        }
        if (allFieldsValid){
            //subContext?.setSubmitValid({...subContext.submitValid, custom: true});
            return (true);
        }else{
            //subContext?.setSubmitValid({...subContext.submitValid, custom: false});
            return (false);
        }
        //console.log(subContext?.submitValid);
   }


   

    const getSteps= ()=>{
        var steps;
        var stepPages;
        switch (props.type){
            case "SB":
                //submission
                if(subContext?.submitForm.pickupWithChanges==false){
                    //Not a straight pickup
                    if (subContext?.submitForm.prCheck==true){
                        //Press ready ad
                        if (subContext.submitForm.adType.value=="DA"){
                            //Press ready DA
                             if (isHold()){
                                steps= [
                                    { label: 'Hold Notes', isValid: undefined },
                                    { label: 'Pickup', isValid: subContext?.submitValid.pickup || true },
                                    { label: 'Files', isValid: subContext?.submitValid.file||true },
                                    { label: 'Details', isValid: subContext?.submitValid.custom||false },
                                    { label: 'Summary', isValid: undefined },
                                ]
                                stepPages=[SubmitHold,SubmitPickup, SubmitFile, SubmitCustom, SubmitSummary]                        
                             }else{
                                steps= [
                                    { label: 'Pickup', isValid: subContext?.submitValid.pickup || true },
                                    { label: 'Files', isValid: subContext?.submitValid.file||true },
                                    { label: 'Details', isValid: subContext?.submitValid.custom||false },
                                    { label: 'Summary', isValid: undefined },
                                ]
                                stepPages=[SubmitPickup, SubmitFile, SubmitCustom, SubmitSummary]                        
                             }
                        }else{
                            //Press Ready RM
                            if (isHold()){
                                steps= [
                                    { label: 'Hold Notes', isValid: undefined },
                                    { label: 'Pickup', isValid: subContext?.submitValid.pickup || true },
                                    { label: 'Files', isValid: subContext?.submitValid.file||true },
                                    { label: 'Details', isValid: subContext?.submitValid.custom||false },
                                    { label: 'Instructions', isValid: subContext?.submitValid.instructions||true },
                                    { label: 'Summary', isValid: undefined },
                                ]
                                stepPages=[SubmitHold,SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                            }else{
                                steps= [
                                    { label: 'Pickup', isValid: subContext?.submitValid.pickup || true },
                                    { label: 'Files', isValid: subContext?.submitValid.file||true },
                                    { label: 'Details', isValid: subContext?.submitValid.custom||false },
                                    { label: 'Instructions', isValid: subContext?.submitValid.instructions||true },
                                    { label: 'Summary', isValid: undefined },
                                ]
                                stepPages=[SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]                                
                            }
                        }
                    }else{
                        //Not Press Ready
                        if (isHold()){
                            steps= [
                                { label: 'Hold Notes', isValid: undefined },
                                { label: 'Pickup', isValid: subContext?.submitValid.pickup || true },
                                { label: 'Files', isValid: subContext?.submitValid.file||true },
                                { label: 'Details', isValid: subContext?.submitValid.custom||false },
                                { label: 'Instructions', isValid: subContext?.submitValid.instructions||true },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitHold,SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]                        
                        }else{
                            steps= [
                                { label: 'Pickup', isValid: subContext?.submitValid.pickup || true },
                                { label: 'Files', isValid: subContext?.submitValid.file||true },
                                { label: 'Details', isValid: subContext?.submitValid.custom||false },
                                { label: 'Instructions', isValid: subContext?.submitValid.instructions||true },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                        }
                    }
                }else{      
                    //Straight pickup              
                    steps= [
                        { label: 'Pickup', isValid: subContext?.submitValid.pickup||true },
                        { label: 'Summary', isValid: undefined },
                    ]
                    stepPages=[SubmitPickup, SubmitSummary]
                }                break;
            case "PU":
                steps= [
                        { label: 'PickupTo', isValid: subContext?.submitValid.pickup||true }
                    ]
                    stepPages=[SubmitPickupTo]
                break;
            case "CR":
                //correction
                if (isHold()){
                    if(pageContext?.selectedAd.elementType=="DA"){
                        steps = [
                            { label: 'Hold Notes', isValid: undefined },
                            { label: 'Annotations', isValid: undefined },
                            { label: 'Files', isValid: undefined },
                            { label: 'Details', isValid:undefined},
                            { label: 'Instructions', isValid: undefined },
                            { label: 'Summary', isValid: undefined },
                        ]
                        stepPages=[SubmitHold,SubmitNotations, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                    }else{
                        //Digital Proof
                        if(pageContext?.selectedAd.temp6=="Built by Creatopy"){
                            steps = [
                                { label: 'Hold Notes', isValid: undefined },
                                { label: 'Annotations', isValid: undefined },
                                { label: 'Files', isValid: undefined },
                                { label: 'Details', isValid: undefined },
                                { label: 'Instructions', isValid: undefined },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitHold, SubmitNotations,SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                        }else{ 
                            steps = [
                                { label: 'Hold Notes', isValid: undefined },
                                { label: 'Files', isValid: undefined },
                                { label: 'Details', isValid: undefined },
                                { label: 'Instructions', isValid: undefined },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitHold, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]
                        }    
                    } 
                }else{
                    if(pageContext?.selectedAd.elementType=="DA"){
                        steps = [
                            { label: 'Annotations', isValid: undefined },
                            { label: 'Files', isValid: undefined },
                            { label: 'Details', isValid: undefined },
                            { label: 'Instructions', isValid: undefined },
                            { label: 'Summary', isValid: undefined },
                        ]
                        stepPages=[SubmitNotations, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                    }else{
                        //Digital Proof
                        if(pageContext?.selectedAd.temp6=="Built by Creatopy"){
                            steps = [
                                { label: 'Annotations', isValid: undefined },
                                { label: 'Files', isValid: undefined },
                                { label: 'Details', isValid: undefined },
                                { label: 'Instructions', isValid: undefined },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitNotations,SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                        }else{                            
                            steps = [
                                { label: 'Files', isValid: undefined },
                                { label: 'Details', isValid: undefined },
                                { label: 'Instructions', isValid: undefined },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]    
                        }
                    } 
                }
                break;
            case "SP":
                //specAd
                steps= [
                    { label: 'Ad Info', isValid: undefined },
                    { label: 'Sizes', isValid: undefined },
                    { label: 'Pickup', isValid: undefined },
                    { label: 'Files', isValid: undefined },
                    { label: 'Details', isValid: undefined },
                    { label: 'Instructions', isValid: undefined },
                    { label: 'Summary', isValid: undefined },
                ]
                stepPages=[SubmitBasic, SubmitSizes, SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]
                break;
            case "OS":
                //sourcing order
                if(subContext?.submitForm.pickupWithChanges==false){
                    //Not a straight pickup
                    if (subContext?.submitForm.prCheck==true){
                        //Press ready ad
                        if (subContext.submitForm.adType.value=="DA"){
                            //Press Ready DA
                            steps= [
                                { label: 'Ad Info', isValid: undefined },
                                { label: 'Sizes', isValid: undefined },
                                { label: 'Rundates', isValid: undefined },
                                { label: 'Pickup', isValid: undefined },
                                { label: 'Files', isValid: undefined },
                                { label: 'Details', isValid: undefined },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitBasic, SubmitSizes, SubmitRunDates, SubmitPickup, SubmitFile, SubmitCustom, SubmitSummary]
                        }else{
                            //Press ready RM
                            steps= [
                                { label: 'Ad Info', isValid: undefined },
                                { label: 'Sizes', isValid: undefined },
                                { label: 'Rundates', isValid: undefined },
                                { label: 'Pickup', isValid: undefined },
                                { label: 'Files', isValid: undefined },
                                { label: 'Details', isValid: undefined },
                                { label: 'Instructions', isValid: undefined },
                                { label: 'Summary', isValid: undefined },
                            ]
                            stepPages=[SubmitBasic, SubmitSizes, SubmitRunDates, SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]
                        }
                    }else{
                        //Not Press ready
                        steps= [
                            { label: 'Ad Info', isValid: undefined },
                            { label: 'Sizes', isValid: undefined },
                            { label: 'Rundates', isValid: undefined },
                            { label: 'Pickup', isValid: undefined },
                            { label: 'Files', isValid: undefined },
                            { label: 'Details', isValid: undefined },
                            { label: 'Instructions', isValid: undefined },
                            { label: 'Summary', isValid: undefined },
                        ]
                        stepPages=[SubmitBasic, SubmitSizes, SubmitRunDates, SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]
                    }
                }else{
                    //straight pickup
                    steps= [
                        { label: 'Ad Info', isValid: undefined },
                        { label: 'Sizes', isValid: undefined },
                        { label: 'Rundates', isValid: undefined },
                        { label: 'Pickup', isValid: undefined },
                        { label: 'Summary', isValid: undefined },
                    ]
                    stepPages=[SubmitBasic, SubmitSizes, SubmitRunDates, SubmitPickup, SubmitSummary]
                }
                break;
            case "NO":
                //New Ad
                steps= [
                    { label: 'Ad Info', isValid: undefined },
                    { label: 'Sizes', isValid: undefined },
                    { label: 'Rundates', isValid: undefined },
                    { label: 'Pickup', isValid: undefined },
                    { label: 'Files', isValid: undefined },
                    { label: 'Details', isValid: undefined },
                    { label: 'Instructions', isValid: undefined },
                    { label: 'Summary', isValid: undefined },
                ]
                stepPages=[SubmitBasic, SubmitSizes, SubmitRunDates, SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]
                break;
            case "AI":
                //Creatopy AI
                steps= [
                    { label: 'Ad Info', isValid: undefined },
                    //{ label: 'Sizes', isValid: undefined },
                    { label: 'Summary', isValid: undefined },
                ]
                stepPages=[SubmitBasic,SubmitSummary]
                break;
            default:
            steps= [
                { label: 'Ad Info', isValid: undefined },
                { label: 'Sizes', isValid: undefined },
                { label: 'Rundates', isValid: undefined },
                { label: 'Pickup', isValid: undefined },
                { label: 'Files', isValid: undefined },
                { label: 'Details', isValid: undefined },
                { label: 'Instructions', isValid: undefined },
                { label: 'Summary', isValid: undefined },
            ]
            stepPages=[SubmitBasic, SubmitSizes, SubmitRunDates, SubmitPickup, SubmitFile, SubmitCustom, SubmitInstructions, SubmitSummary]
            break;
        }
        updateSteps(steps);
        updateStepPages(stepPages);
    }

    const updateSteps=(stepsToSet: any[])=>{
        setSteps(stepsToSet);
    }

    const updateStepPages=(stepsToSet: any[])=>{
        SetStepPages(stepsToSet);
    }

    const setForm=()=>{
        console.log("Set Form");
        subContext?.setSubmitForm(prevObject=>({...prevObject,subType:props.type}));
        switch(props.type){
            case "SB":
            case "CR":
            case "PU":
                console.log("SB or CR");
                if (pageContext?.selectedAd){
                    const cust=pageContext?.selectedAd.customer;
                    const acct = pageContext?.selectedAd.fileSize2;
                    const site = pageContext?.selectedAd.file1;
                    const salesRep = pageContext.selectedAd.salesman;
                    const custObj={customer:cust,fileSize2:acct,file1:site};
                    const siteObj={code:pageContext?.selectedAd.file1,
                        name:"",
                        logo_Prefix:"",
                        primary_ip:"",
                        backup_ip:"",
                        temp_Char:"",
                        temp_Int:0,
                        vol1_Unc_Path:"",
                        vol2_Unc_Path:""}
                    const elType = pageContext?.selectedAd.elementType;
                    subContext?.setSubmitForm(prevObject=>({...prevObject,adType:{text:elType, value:elType}}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,element:pageContext?.selectedAd.element}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,slug:pageContext?.selectedAd.slug}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,site:siteObj}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,customer:custObj}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,salesRep:{customer:salesRep, displayName:"",security:1,temp4:"",fullName:""}}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,account:pageContext?.selectedAd.fileSize2}));
                    subContext?.setSubmitForm(prevObject=>({...prevObject,size:[{size:pageContext?.selectedAd.size, strIn:"",strOut:"",modId:"",siteCode:""}]}));
                    const adStatus = pageContext.selectedAd.status;
                    const holdStatuses = pageContext.atolStatuses.HoldStatuses;
                    if (holdStatuses.indexOf(adStatus)!=-1){
                        subContext?.setSubmitForm(prevObject=>({...prevObject,isHold:true}));
                    }
                }
        }
    }

    const setSubmitSiteFlag=(flag:string)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,siteFlag:flag}));
    }
    
    const closeConfirmWindow=()=>{
        setShowCloseConfirm(false);
    }
    const confirmCloseWindow=()=>{
        setShowCloseConfirm(false);
        logHistoryCancelled();
        props.onClose();
    }
    const confirmClose=()=>{
        setShowCloseConfirm(true);
    }

    const stopTimers=()=>{
        pageContext?.setTimerActive(false);
    }

    const onLoad=()=>{
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        setWidth(vw);
        setHeight(vh);
        getSteps();
    }

    const logHistoryOpen=()=>{
        if (subContext){
            const newHistory:HistoryEntry={element:subContext.submitForm.element, opID:9, operation:"Submit form opened", status:""};
            writeToHistory(newHistory);
        }
    }

    const logHistoryCancelled=()=>{
        if (subContext){
            const newHistory:HistoryEntry={element:subContext.submitForm.element, opID:9, operation:"Submission or Correction canceled by user", status:""};
            writeToHistory(newHistory);
        }
    }

    const processUpload=()=>{
        console.log ("Process Submission");
        console.log(subContext?.submitForm);
        console.log(subContext?.files);
        if (subContext?.files.length||0>0){
            console.log ("Uploading Files");
            uploadFiles().then(()=>{
                console.log("Finished uploads");
            });
        }else{
            setUploadComplete(true);
            console.log ("No files to upload");
        }
    }

    const saveCustomResponse=()=>{
        var frmResponses:{element:string, fieldID:number, value:string, weight:number}[] = [];
        var element:string = "";
        if (subContext?.submitForm.element.includes(".INDD")||subContext?.submitForm.element.includes(".FLA")){
            element=subContext?.submitForm.element||"";
        }else{
            //need to add an extension to the element field.
            if (subContext?.submitForm.adType.value=="DA"){
                //print ads
                element=subContext?.submitForm.element+".INDD"||"";
            }else{
                //online ads
                element=subContext?.submitForm.element+".FLA"||"";
            }
        }
        if (subContext){
            if (subContext.fields){
                if (subContext.customFieldData){
                    subContext.fields.map(field=>{
                        const prompt = field.label;
                        var resp = subContext.customFieldData[field.fieldID];                        
                        if (resp!=undefined){
                            switch (field.type){
                                case "TextBox":
                                case "LongText":
                                case "Email":
                                case "URL":
                                case "text":
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:resp,weight:0})                                    
                                    break;
                                case "Phone":
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:resp,weight:0})
                                    break;
                                case "RadioButtonList":
                                    if (typeof(resp)=="string"){
                                        resp = JSON.parse(resp);
                                    }
                                    var rblResp = Object(resp).value;
                                    var rblWeight=Object(resp).weight;
                                    if (!rblResp){

                                    }
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:rblResp,weight:rblWeight})
                                    break;
                                case "CheckBoxList":
                                    const cblObj = JSON.parse(resp);
                                    var cblResp = "";
                                    console.log(cblObj);
                                    cblObj.forEach((obj:{index: number, text: string, value: string, weight: number}) => {
                                        console.log(obj);
                                        if (cblResp ==""){
                                            cblResp=obj.value;
                                        }else{
                                            cblResp = cblResp + ", " + obj.value;
                                        }
                                    });
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:cblResp,weight:0})
                                    break;
                                case "ComboBox":
                                    const cmbResp = Object(resp).value;
                                    const cmbWeight = Object(resp).weight;
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:cmbResp,weight:cmbWeight})
                                    break;
                                case "DatePicker":
                                    //const dtpResp = Object(resp).text;
                                    const dtpResp = resp;
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:dtpResp,weight:0})
                                    break;
                                case "ColorPicker":
                                    const clrResp = Object(resp).text;
                                    frmResponses.push({element:element,fieldID:field.fieldID,value:clrResp,weight:0})
                                    break;
                            }
                        }
                    });
                    subContext?.setSubmitForm(prevObject=>({...prevObject,custom:frmResponses}));
                }
            }
        }        
    }

    const submitAdOrder=()=>{
        const oType = subContext?.submitForm.subType;
        var formData:SubToProcess={
            subType:"",
            adType:"",
            element:"",
            site:"",
            extension:"",
            slug:"",
            customer:"",
            category:"",
            account:"",
            salesRep:"",
            color:"",
            pickup:"[]",
            tagline:"",
            comment:"",
            deadlineType:"",
            size:"",
            date:"",
            prCheck:false,
            prConfirm:"",        
            allFilesIn:false,
            multiPage:false,
            copyCampaign:false,
            noFiles:false,
            setStatus:"",
            zone0:"",
            path:"",
            timeStamp:0,
            source:"",
            multiPickup:false,
            ticket:"",
            custom:"",
            submissionEmail:"",
            correctionEmail:"",
            annotations:"[]",
            isHold:false,
            instructionsNotFollowed:false,
            additionalCorrections:false,
            siteFlag:"",
            useClipper:false,
            pickupWithChanges:false
        };
        var ext:string="";
        if (subContext?.submitForm.adType.value=="DA"){
            ext=pageContext?.glSettings.StaticAdExtension.toString()||"DA";    
        }else{
            ext=pageContext?.glSettings.DynamicAdExtension.toString()||"DA";    
        }
        const salesRep = subContext?.submitForm.salesRep as salesRep;
        
        switch (oType){
            case "NO":
            case "MK":
            case "DT":
            case "OS":
            case "SP":
            case "AI":
                //New ad order
                formData.subType=oType;
                formData.adType=subContext?.submitForm.adType.value||"";
                if (subContext?.submitForm.element.includes(".INDD")||subContext?.submitForm.element.includes(".FLA")){

                    formData.element=subContext?.submitForm.element||"";
                }else{
                    //need to add an extension to the element field.
                    if (subContext?.submitForm.adType.value=="DA"){
                        //print ads
                        formData.element=subContext?.submitForm.element+".INDD"||"";
                    }else{
                        //online ads
                        formData.element=subContext?.submitForm.element+".FLA"||"";
                    }
                }
                formData.site=subContext?.submitForm.site.code||"";
                formData.extension=ext||"";
                formData.slug=subContext?.submitForm.slug||"";
                formData.customer=subContext?.submitForm.customer.customer||"";
                formData.account=subContext?.submitForm.account||"";
                formData.salesRep=salesRep.customer||"";
                if (subContext?.submitForm.color.value=="1"){
                    formData.color="1";
                }
                formData.pickup=subContext?.submitForm.pickup||"[]";
                formData.pickupWithChanges=subContext?.submitForm.pickupWithChanges||false;
                formData.tagline=subContext?.submitForm.tagline||"";
                formData.comment=subContext?.submitForm.comment||"";
                formData.deadlineType=subContext?.submitForm.deadlineType.value||"";
                formData.category=subContext?.submitForm.category.category||"";
                var size:{colType:string, size:string,strIn:string}[]=[];
                if (subContext?.submitForm.category.type=="N"){
                    if (oType=="SP"){
                        subContext?.submitForm.size.map((itm)=>{
                            const type=itm.type;
                            const sz = itm.size;
                            const strIn=itm.strIn;
                            size.push({colType:type,size:sz,strIn:strIn});
                        })
                    }else{
                        size.push({colType:subContext?.submitForm.category.category,size:subContext?.submitForm.size[0],strIn:subContext?.submitForm.size[0]});
                    }
                }else{
                    if (oType=="SP"){
                        subContext?.submitForm.size.map((itm)=>{
                            size.push({colType:itm.type,size:itm.size,strIn:itm.strIn});
                        })
                    }else{
                        subContext?.submitForm.size.map((itm)=>{
                            size.push({colType:itm.modCategory,size:itm.size,strIn:itm.strIn});
                        })
                    }
                }
                formData.size=JSON.stringify(size);
                if (oType=="SP"||oType=="AI"){
                    const pub = pageContext?.glSettings.SpecPub
                    const today = new Date();
                    const pubDate = new Date(today.setDate(today.getDate()+30));
                    const newPubDate:NewRunDate[]=[{pubName:"Spec", pubNum:Number(pub) || 0, startDate: pubDate, endDate: pubDate}]
                    formData.date = JSON.stringify(newPubDate);
                }else{
                    formData.date=JSON.stringify(subContext?.submitForm.runDates)||"";
                }
                formData.prCheck=subContext?.submitForm.prCheck||false;
                formData.prConfirm=subContext?.submitForm.prConfirm.value||"";
                formData.allFilesIn=subContext?.submitForm.allFilesIn||false;
                formData.multiPage=subContext?.submitForm.multiPage||false;
                formData.copyCampaign=subContext?.submitForm.copyCampaign||false;
                formData.noFiles=subContext?.submitForm.noFiles||false;
                formData.custom=JSON.stringify(subContext?.submitForm.custom)||""               
                formData.annotations="[]";
                break;                
            case "SB":
            case "CR":
                //Submit to existsing
                formData.subType=oType;
                formData.adType=subContext?.submitForm.adType.value||"";
                formData.element=subContext?.submitForm.element||"";
                formData.site=subContext?.submitForm.site.code||"";
                formData.customer=subContext?.submitForm.customer.customer||"";
                formData.category=subContext?.submitForm.category.category||"";
                formData.account=subContext?.submitForm.account||"";
                formData.salesRep=subContext?.submitForm.salesRep.customer||"";
                formData.pickup=subContext?.submitForm.pickup||"[]";
                formData.size="[]";
                formData.date="[]";
                formData.pickupWithChanges=subContext?.submitForm.pickupWithChanges||false;
                formData.prCheck=subContext?.submitForm.prCheck||false;
                formData.prConfirm=subContext?.submitForm.prConfirm.value||"";
                formData.allFilesIn=subContext?.submitForm.allFilesIn||false;
                formData.multiPage=subContext?.submitForm.multiPage||false;
                formData.copyCampaign=subContext?.submitForm.copyCampaign||false;
                if (subContext?.files && subContext?.files.length>0){
                    formData.noFiles=subContext?.submitForm.noFiles||false;
                }else{
                    formData.noFiles=subContext?.submitForm.noFiles||true;
                }
                //formData.noFiles=subContext?.submitForm.noFiles||false;
                formData.instructionsNotFollowed=subContext?.submitForm.instructionsNotFollowed||false;
                formData.additionalCorrections=subContext?.submitForm.additionalCorrections||false;
                formData.custom=JSON.stringify(subContext?.submitForm.custom)||""               
                //Annotations
                formData.annotations="[]";
                formData.isHold=subContext?.submitForm.isHold||false;
                formData.useClipper=subContext?.submitForm.useClipper||false;
                break;                
            case "PU":
                formData.subType=oType;
                formData.element=subContext?.submitForm.element||"";
                formData.pickup=subContext?.submitForm.pickup||"";
                formData.pickupWithChanges=subContext?.submitForm.pickupWithChanges||false;
                break;
        }
        console.log(formData);
        processSubmission(formData).then(resp=>{
            console.log(resp);
            if (resp=="200"){
                if (subContext){                
                    const newHistory:HistoryEntry={element:subContext.submitForm.element, opID:9, operation:"Submission or Correction submitted", status:""};
                    writeToHistory(newHistory);
                    if (subContext.submitForm.addWatch){
                        const adNum = subContext.submitForm.element;
                        const ext = subContext.submitForm.extension;
                        if (adNum.substring(adNum.length-ext.length)===ext){
                            addWatchList(subContext.submitForm.element);
                        }else{
                            addWatchList(subContext.submitForm.element+ext);
                        }
                    }
                }
                completeProcess(resp);
            }
        })
    }

    const resizeWindow=()=>{
        const thisWindow = document.getElementById("submitWindow");
        if (thisWindow){
            const windowHeight = thisWindow?.offsetHeight;
            var formBody = document.getElementById("formbody");
            var newHeight = windowHeight-258;
            if (formBody){
                formBody.style.height=newHeight.toString()+"px";
            }    
        }
    }

    const pickupConfirmYes=()=>{
        let pickupStep=step;
        steps.forEach((step,index) => {
            if (step.label==="Pickup"){
                pickupStep=index;
            }
        });
        if (pickupStep!=step){
            setStep(pickupStep);
        }
        setPromptPickup(false);
    }

    const pickupConfirmNo=()=>{
        setPromptPickup(false);
    }


    const ticketIsReady = ()=>{
        setTicketReady(true);
    }


    useEffect(() => {
        stopTimers();
        setForm();
        onLoad();
        console.log(subContext?.submitValid);
    }, []);

    useEffect(()=>{
        const activeTab = steps[step].label;
        if (activeTab==="Annotations"){
            if(thisFormBody.current){
                thisFormBody.current.style.overflow="clip";
            }
        }
    },[steps])

    useEffect(()=>{
        const activeTab = steps[step].label;
        if (activeTab==="Annotations"){
            if(thisFormBody.current){
                thisFormBody.current.style.overflow="clip";
            }
        }else{
            if(thisFormBody.current){
                thisFormBody.current.style.overflow="scroll";
            }
        }
    },[step])   

    useEffect(()=>{
        logHistoryOpen();
    },[subContext?.submitForm.element]);


    useEffect(()=>{
        const activeTab = steps[step].label;
        console.log (activeTab);
        console.log(subContext?.submitValid);
    },[subContext?.submitValid])

    useEffect(()=>{
        console.log("Upload complete: " + uploadComplete);
        if (uploadComplete==true){
            if (subContext?.submitForm.subType=="PU"){
                //no ticket for a pickup
                completeTicket("200");
            }else{
                setTimeout(()=>{
                    makeJobTicket().then(data=>{
                        saveCustomResponse();
                        completeTicket(data||"");
                    });
                },3000)
            }
        }
    },[uploadComplete])

    useEffect(()=>{
      console.log("Ticket Complete: " + ticketComplete);
        setShowTicketStatus(true);
        if (ticketComplete=="200"){
            if (subContext?.submitForm.annotations && subContext?.submitForm.annotations.length>0){
                saveAnnotations(subContext.submitForm.annotations,subContext.submitForm.element,subContext.submitForm.noteColor,userContext?.user.username||"ATOL");
            }
            submitAdOrder();            
        }
    },[ticketComplete])

    useEffect(()=>{
        if (processComplete){
            setShowProcessStatus(true);
        }
    },[processComplete])


    useEffect(()=>{
        console.log("Progress change");
        console.log(progress + "/" + progressMax);
        if (progress==progressMax){
            setUploadComplete(true);
        }
    }, [progress])
    
    useEffect(()=>{
        console.log("Set max files");
        const maxFiles = subContext?.files?.length ?? 0;
        if (maxFiles>0){
            console.log("Max Files: " + maxFiles);
            setProgressMax(maxFiles);    
        }
    },[subContext?.files])

    useEffect(() => {     
        getSteps();
    }, [subContext?.submitForm.pickupWithChanges, subContext?.submitForm.prCheck]);

    useEffect(()=>{
        if (subContext?.submitForm.site.code){
            getSiteFlag(subContext?.submitForm.site.code).then(data=>{
                console.log("SiteFlag:" + data);
                var setVal="";
                if (data.length>0){
                    if (Array.isArray(data) && data[0]?.contact_Phone2 === "K") {
                        setVal= "K"
                    }else{
                        setVal= "G"
                    }  
                }else{
                    setVal= "G"
                }
                setSubmitSiteFlag(setVal);
            })
        }
    },[subContext?.submitForm.site])

    return(
        <Window id="submitWindow" title={props.title} onClose={confirmClose} initialHeight={height} initialWidth={width} onResize={resizeWindow} modal={true}>
            {showLoader?
                    <div style={{  display:"flex", justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                        <Loader size="large" type="converging-spinner"></Loader>
                    </div>
            :null}
            {promptPickup?<ConfirmDialog title="Pickup request?" message="It looks like you may be requesting a pickup, but have not selected the ad to pickup. Do you want to return to the pickup portion of this form?" type="WARN" confirmButtonText="Yes" cancelButtonText="No" onConfirm={pickupConfirmYes} onClose={pickupConfirmNo}></ConfirmDialog>:null}
            {showCloseConfirm?<ConfirmDialog type="WARN" title='WARNING' message='Your submission is incomplete and will not be processed. Are you sure you want to close this window?' confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmCloseWindow} onClose={closeConfirmWindow}   ></ConfirmDialog>:null}
            {showConfirmOpenAd?<ConfirmDialog type="INFO" title="Open External Ad Builder" message="You are leaving AdTracker Online. You be redirected to the external ad building application." confirmButtonText="Continue" cancelButtonText="Cancel" onConfirm={openExternalAd} onClose={closeConfirmOpenAd}></ConfirmDialog>:null}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Stepper value={step} items={steps} />
                {showValidationAlert ? <Notification type={{ style: "error", icon: true }} closable={true} onClose={closeValidation}>{validationMsg}</Notification> : null}
                {windowContent=="form"?
                    <Form
                        id="submitform"
                        initialValues={formState}
                        onSubmitClick={onNext}
                        render={(formRenderProps) => (
                            // <div style={{ alignSelf: 'center' }}>
                                <FormElement style={{ width:"99%", marginTop:20 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                        <div>
                                            {step !== 0 ? (
                                                <Button size={"large"} style={{ marginRight: '16px' }} onClick={onPrevClick}>
                                                    Previous
                                                </Button>
                                            ) : undefined}
                                            <Button
                                                size={"large"}
                                                themeColor={'primary'}
                                                disabled={isLastStep ? !isPreviousStepsValid : false}
                                                onClick={formRenderProps.onSubmit}
                                            >
                                                {isLastStep ? 'Submit' : 'Next'}
                                            </Button>
                                        </div>
                                    </div>
                                    <span style={{ marginTop: '10px', marginBottom:10}} className={'k-form-separator'} />
                                    <div id="formbody" style={{height:600, overflow:"scroll"}} ref={thisFormBody}>
                                    {stepPages[step]}
                                    </div>
                                    <span style={{ marginTop: '10px', marginBottom:10}} className={'k-form-separator'} />
                                    <span style={{ alignSelf: 'center' }}>Step {step + 1} of {steps.length}</span>
                                </FormElement>
                            // </div>
                        )}
                    />
                :
                //Finished job ticket
                <div>  
                    <div className="submitProgress">                  
                        {uploadComplete?
                            subContext?.submitForm.subType!="PU"?
                            <>
                            <p><strong>Submission Progress:</strong></p>
                            <p>...File uploads complete</p>
                            </>:null
                        :   
                        <ProgressBar min={0} max={progressMax} value={progress} animation={true}></ProgressBar>
                        }
                        {showTicketStatus && subContext?.submitForm.subType!="PU"?
                            <>
                            {ticketComplete!="error"?
                                <p>...Job ticket updated</p>                
                            :
                                <p className="error">...Error updating job ticket</p>                
                            }
                            </>
                        :null}
                        {showProcessStatus?
                            <>
                            {processComplete!="error"?
                                subContext?.submitForm.subType!="PU"?
                                <p>...Ad order submitted</p>:
                                <p>...Pickup requested</p>                
                            :
                                <p className="error">...Error submitting ad order</p>                
                            }
                            {subContext?.submitForm.subType=="AI"?
                                <Button onClick={openExternalAd} themeColor={'primary'}>Open Ad</Button>
                                :
                                <Button onClick={props.onClose} themeColor={'primary'}>Close</Button>
                            }
                            </>
                        :null}
                    </div>
                    {subContext?.submitForm.subType!="PU"?
                    <div className="mt-3" id="jobTicket">                        
                        <div className="submission" ref={jobTicketRef}>
                            <SubmitComplete/>
                            {subContext?.files.length||0>0?
                            <>
                            <h5>Files Submitted</h5>    
                            <Grid
                                data={uploadResults}
                            >
                                <GridColumn field='OriginalName' title='Original Name' />
                                <GridColumn field='NewName' title='Uploaded Name' />
                                <GridColumn field='Type' title='Type' />
                                <GridColumn field='Size' title='Size' />
                            </Grid>
                            </>
                            :null}
                        </div>
                    </div>:
                    <div className="mt-3" id="pickupResult">
                        <div className="submission">
                            <h5>Pickup Request Submitted</h5>
                            <p>Pickup of {subContext?.submitForm.element} to {subContext?.submitForm.pickup} has been requested.</p>
                        </div>
                    </div>}
                </div>
                }
                
            </div>
        </Window>
    )
}
